<template>
	<expand-list
		:title="$t('COMMENT_LIST_TITLE', { n: comments.length })"
		:no-data-text="$t('COMMENT_LIST_NO_DATA_TEXT')"
		:maxVisibleItems="maxVisibleComments"
		:maxInlineItems="maxInlineComments"
		:color="color"
		:items="comments"
		@showAll="showAll">
	
		<template v-slot="{ item: comment }">
			<comment :item="comment" :key="comment.id" @edit="saveComment" @remove="deleteComment"/>
		</template>

		<!-- new comment input -->
		<template #footer>
			<v-layout class="mt-3 pb-2 pl-1">
				<v-flex shrink class="mt-2 mr-3 hidden-xs-only">
					<v-avatar color="#C5E1A5">
						<v-icon>mdi-comment-text-outline</v-icon>
					</v-avatar>
				</v-flex>
				<v-flex>
					<v-textarea
						:label="$t('COMMENT_LIST_ADD_TEXT')"
						v-model="newCommentText"
						hide-details
						box
						auto-grow
						rows="1"
						append-outer-icon="mdi-play"
						@click:append-outer="addComment" />
				</v-flex>
			</v-layout>
		</template>

	</expand-list>
</template>


<script>
import ExpandList from '@/components/ExpandList';
import Comment from '@/components/Comment';


export default {
	name: 'comment-list',
	components: { ExpandList, Comment },
	props: {
		actionID: Number,
		comments: Array,
		maxInlineComments: Number,
		maxVisibleComments: Number,
	},
	data: () => ({
		color: '#C5E1A5',
		newCommentText: '',
	}),
	methods: {
		showAll() {
			this.$emit('showAll');
		},

		async addComment() {
			const { Comment } = this.$FeathersVuex;
			const text = this.newCommentText.trim();
			if (!text) { return }

			const item = new Comment({ action: this.actionID, text });

			await this.saveComment(item);
			this.newCommentText = '';
		},

		async saveComment(item) {
			try {
				await this.$store.dispatch('comments/saveComment', { item });
			}
			catch(err) {
				// TODO
			}
		},

		async deleteComment(item) {
			try {
				await this.$store.dispatch('comments/deleteComment', { item });
			}
			catch(err) {
				// TODO
			}
		},
	}
}
</script>


<style>
</style>
